import * as React from "react";
import { cn } from "../../utils/cn";
import i18n from "../../i18n";
import CustomTooltip from "../tooltip";

export interface TextInputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  error?: string;
  errorStyle?: string;
  label?: string;
  required?: boolean;
  value?: string;
  labelStyle?: string;
  isInfoToolTip?: boolean;
  infoToolTip?: React.ReactNode;
}

const TextInput = React.forwardRef<HTMLInputElement, TextInputProps>(
  (
    {
      className,
      value,
      type = "text",
      error,
      errorStyle,
      label,
      required = false,
      labelStyle,
      isInfoToolTip = false,
      infoToolTip,
      readOnly = false,
      ...props
    },
    ref
  ) => {
    return (
      <div className="relative flex flex-col gap-[3px]">
        <div className="relative flex items-center gap-2">
          {label && (
            <>
              <label className={cn("text-[13px] font-normal", labelStyle)}>
                {label} {required && <span className="text-red-500">*</span>}
              </label>

              {isInfoToolTip && <CustomTooltip>{infoToolTip}</CustomTooltip>}
            </>
          )}
        </div>

        <input
          type={type}
          ref={ref}
          className={cn(
            "flex py-3 px-4 w-full rounded-[15px] border-2 bg-transparent text-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-gray-soft outline-none focus:border-purple-secondary focus:ring-0 disabled:cursor-not-allowed disabled:opacity-50",
            className,
            readOnly && "cursor-not-allowed border-[#F2F3F5] text-[#A2A2A2]"
          )}
          readOnly={readOnly}
          value={value}
          onWheel={(e) => {
            if (type === "number") {
              e.currentTarget.blur();
              e.preventDefault();
            }
          }}
          {...props}
        />
        {!!error && (
          <p
            className={cn(
              "text-red-600 text-[10px] mt-[1px] absolute -bottom-[15px] italic",
              errorStyle,
              i18n.language === "en" ? "left-[2px]" : "right-[2px]"
            )}
          >
            {error}
          </p>
        )}
      </div>
    );
  }
);

export default React.memo(TextInput);
